import useSWRImmutable from 'swr/immutable';
import request from '@/utils/request';

const fetcher = (url: string) =>
    request
        .post<number>(url)
        .then(res => res.data || 0)
        .catch(() => 0);

function useUnreplyCount() {
    const { data, error, mutate } = useSWRImmutable('/api/evaluate/unreply/count', fetcher);
    return { data, error, mutate };
}

export default useUnreplyCount;
